import { FormikProps } from "formik";
import { useEffect } from "react";

import { IEditableSectionProps } from "./types";

export const useEditableSubmit = <T = any>(form: FormikProps<T>, editableProps: IEditableSectionProps) => {
  useEffect(() => {
    const onSubmit = async () => {
      if (editableProps.saveClicked) {
        await form.submitForm();
        editableProps.handleCancelSubmit();
      }
    };
    onSubmit();
  }, [editableProps.saveClicked]);

  useEffect(() => {
    editableProps.setSubmitting(form.isSubmitting);
  }, [form.isSubmitting]);
};
